import { createApi } from "@reduxjs/toolkit/query/react";
import axiosBaseQuery from "./axiosBaseQuery/axiosBaseQuery";
import config from "../../config/config";

export const growthPlanNotesAPI = createApi({
  reducerPath: "growthPlanNotesAPI",
  baseQuery: axiosBaseQuery({
    baseUrl: config?.appUrl,
  }),
  keepUnusedDataFor: 900,
  tagTypes: ["growthPlanNotes"],
  endpoints: (builder) => ({
    getGrowthPlanNotesList: builder.query<any, { affiliateCode: string; aboNumber: string; goalId: number }>({
      query: ({ affiliateCode, aboNumber, goalId }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/notes/type/goal/${goalId}`,
        method: "GET",
      }),
      providesTags: ["growthPlanNotes"],
    }),

    createGrowthPlanNote: builder.mutation<any, { affiliateCode: string; aboNumber: string; goalId: number; payload: any }>({
      query: ({ affiliateCode, aboNumber, goalId, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/create/type/goal`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["growthPlanNotes"],
    }),

    updateGrowthPlanNote: builder.mutation<any, { affiliateCode: string; aboNumber: string; goalId: number; payload: any }>({
      query: ({ affiliateCode, aboNumber, goalId, payload }) => ({
        url: `/am/abo/${affiliateCode}/${aboNumber}/note/update/type/goal`,
        method: "POST",
        data: payload,
      }),
      invalidatesTags: ["growthPlanNotes"],
    }),

    deleteGrowthPlanNote: builder.mutation<any, { id: string | number }>({
      query: ({ id }) => ({
        url: `/am/abo/note/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["growthPlanNotes"],
    }),
  }),
});

export const {
  useGetGrowthPlanNotesListQuery,
  useCreateGrowthPlanNoteMutation,
  useUpdateGrowthPlanNoteMutation,
  useDeleteGrowthPlanNoteMutation,
} = growthPlanNotesAPI;
